function initPastaelPromoStickerReveal(root = document) {
  const stickerGroups = root.querySelectorAll(
    '.pastael-promo-collection__stickers:not(.is-visible)'
  );
  if (!stickerGroups.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion) {
    stickerGroups.forEach((group) => group.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.2,
    }
  );

  stickerGroups.forEach((group) => observer.observe(group));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPastaelPromoStickerReveal());
} else {
  initPastaelPromoStickerReveal();
}

document.addEventListener('shopify:section:load', (event) => {
  initPastaelPromoStickerReveal(event.target);
});
